export class Step3 {
	public intitule = 'stepper.form.simp_an.step3';

	public getspan2 = 'form.simp_an.getspan2';
	public getspan3 = 'form.simp_an.getspan3';
	public getspan4 = 'form.simp_an.getspan4';

	public getintitule = 'form.simp_an.getintitule';
	public classPrincipale = 'form.simp_an.getclassprincipale';
	public classSupplementaire = 'form.simp_an.getclassSupplementaire';
	public travaux = 'form.simp_an.gettravaux';
	public fournitures = 'form.simp_an.getfournitures';
	public services = 'form.simp_an.getservices';
	public description = 'form.simp_an.getdescription';
	public motClef = 'form.simp_an.getmotclef_liste_avi_';

	constructor() {}
}
